<template>
    <div class="jumbotron jumbotron-parapple">
        <div class="container">
            <h1>Hello, welcome to Parapple!</h1>
            <p class="subtitle">Online platform for parallel programming tutorials</p> 
            <hr/>
            <div class="row">
                <div class="col-sm-6 col-md-4">
                    <div class="thumbnail thumbnail-parapple">
                        <img src="../../assets/parallel.png">
                        <div class="caption">
                            <h3>Parallel Programming?</h3>
                            <p>Running more programs in parallel (think multiple servers/CPUs/threads...) is cool, but it can get <a target=_balnk href="http://www.thinkingparallel.com/2007/08/06/what-makes-parallel-programming-hard/">hard</a>.
                            <p>On this platform, you can try parallel programming exercies by writing code for multiple <em>agents</em> and run the simulation right in your browser.</p>
                            <p><router-link to="/docs">Read more...</router-link></p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4">
                    <div class="thumbnail thumbnail-parapple">
                        <img src="../../assets/parascript.png">
                        <div class="caption">
                            <h3>Coding in Parascript</h3>
                            <p>The tutorials are solved by programming the agents in Parascript&mdash;a simplified clone of JavaScript. The syntax should feel very familiar if you know the basics of any C-like language.</p>
                            <p><router-link to="/docs">Documentation</router-link></p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4">
                    <div class="thumbnail thumbnail-parapple">
                        <img src="../../assets/ladybugs.png">
                        <div class="caption">
                            <h3>Extensions &amp; Visualizations</h3>
                            <p>Packages written in JavaScript can add arbitrary functionality to the Parascript programming language. They can also provide visualizations for the tutorials. Most tutorials you'll find here use the sample <em>Ladybugs package</em> which runs on top of <a href="http://www.pixijs.com/">PixiJS</a>.</p>
                            <p><a href="static/devDocs.pdf" target="_blank">Developing packages and tutorials</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p>
            
        </p>
        <hr/>
        <div>Parapple is developed as a master thesis project by <a href="mailto:emanuel.buzek@roke.cz">Emanuel Buzek</a> at <a target=_blank href="https://www.mff.cuni.cz/to.en/">MFF UK</a>.</div>
        <div>Icons made by <a target=_blank href="http://www.freepik.com" title="Freepik">Freepik</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a> licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div>
    </div>
</template>

<script>
    export default {
        name: "welcome",
        data() {
            return {
            }
        },
        methods: {
        },
        mounted() {
        },
        components: {
        }
    }
</script>

<style scoped>
    div.jumbotron p {
        font-size: 14px !important;
    }
    div.jumbotron p.subtitle {
        font-size: 21px !important;
    }
    div.jumbotron-parapple {
        border: 1px solid #ddd !important;
        background-color: white !important;
        padding: 24px !important;
    }
    div.thumbnail-parapple {
        border: none !important;
    }
    div.thumbnail-parapple img {
        border-radius: 5px;
    }
</style>


// WEBPACK FOOTER //
// Welcome.vue?1a89ce60